import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

const map85 = new Map();
const mapSecond85 = new Map();
const map93 = new Map();

function FileComparer({excelData}: Props) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try {
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.OldSheet !== undefined && excelData.Sheets.NewSheet !== undefined) {

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let oldSheetDataArray = extractWorkSheetData(excelData.Sheets.OldSheet);

            let oldArray : any[] = oldSheetDataArray[0];
            let oldColumnRange : number = oldSheetDataArray[1];
            let oldRowRange : number = oldSheetDataArray[2];

            let newSheetDataArray: any[] = extractWorkSheetData(excelData.Sheets.NewSheet);

            let newArray : any[] = newSheetDataArray[0];
            let newColumnRange : number = newSheetDataArray[1];
            let newRowRange : number = newSheetDataArray[2];

            //console.log(newArray);

            //headers
            let headerArray = newArray.slice(0, newColumnRange);

            //for our changes list
            let changedMembers : any[] = [];
            //for our sheet with removed volumes
            let updatedNewArray : any[] = [];

            changedMembers.push(headerArray);
            updatedNewArray.push(headerArray);

            //map old members with any 85 or 93 instances
            for (let i = 1; i < oldRowRange; i++) {
                let memberArray: any[] = [];

                let rowMultiplier = oldColumnRange * i - 1;

                //grab each member
                memberArray = oldArray.slice(rowMultiplier + 1, rowMultiplier + oldColumnRange + 1);
                //console.log(memberArray, "oldMembos");
                let index85 : number = memberArray.indexOf(85);
                let second85Index = memberArray.indexOf(85, index85+1);
                //use SSN for key
                let ssnString = memberArray[0].toString();
                //not dependents
                if(memberArray[1].toString() === "0") {
                    //has 85, else 0
                    if (index85 >= 0) {
                        map85.set(ssnString, memberArray[index85 + 3]);
                    }
                    else {
                        map85.set(ssnString.toString(), 0);
                    }

                    //can be two 85s
                    if (second85Index >= 0) {
                        mapSecond85.set(ssnString, memberArray[second85Index + 3]);
                    }
                    else {
                        mapSecond85.set(ssnString, 0);
                    }

                    //has 93, else 0
                    let index93: number = memberArray.indexOf(93);
                    if (index93 >= 0) {
                        map93.set(ssnString, memberArray[index93 + 3]);
                    }
                    else {
                        map93.set(ssnString, 0);
                    }
                }
            }

            //new list loop, can be more members than the old
            for (let i = 1; i < newRowRange; i++) {
                let memberArray: any[] = [];

                let rowMultiplier = newColumnRange * i - 1;

                memberArray = newArray.slice(rowMultiplier + 1, rowMultiplier + newColumnRange + 1);
                //console.log(memberArray, "newMembos");
                //deep copy of member to avoid transformations on the member as we go
                let beforeChangesMemberArray: any[] = JSON.parse(JSON.stringify(memberArray));
                //map key for searching
                let ssnString = memberArray[0].toString();
                //no dependents
                if(memberArray[1].toString() === "0") {
                    let index85: number = memberArray.indexOf(85);
                    let second85Index = memberArray.indexOf(85, index85+1);
                    //value checks so changed members are only added once to the change list
                    let has85Change = false;
                    let hasSecond85Change = false;

                    //has 85, was on old sheet, and did not change so it just gets cleared
                    if (index85 >= 0 && map85.has(ssnString) && (map85.get(ssnString) === beforeChangesMemberArray[index85 + 3])) {
                        memberArray[index85 + 3] = "";
                    }
                    //has 85 and was on old so gets added to changes and cleared
                    else if (index85 >= 0 && map85.has(ssnString)) {
                        has85Change = true;
                        changedMembers.push(beforeChangesMemberArray);
                        memberArray[index85 + 3] = "";
                    }
                    //has 85 but not on old sheet so a new addition just gets cleared volumes
                    else if (index85 >= 0){
                        memberArray[index85 + 3] = "";
                    }
                    //was on old, had volume previously, but cleared it so they are added to changes
                    else if (map85.has(ssnString) && map85.get(ssnString) !== 0) {
                        has85Change = true;
                        changedMembers.push(beforeChangesMemberArray);
                    }

                    //has second 85, was on old sheet, and did not change so it just gets cleared
                    if (second85Index >= 0 && mapSecond85.has(ssnString) && (mapSecond85.get(ssnString) === beforeChangesMemberArray[second85Index + 3])) {
                        memberArray[second85Index + 3] = "";
                    }
                    //has 85 and was on old so gets added to changes if not already and cleared
                    else if (second85Index >= 0 && mapSecond85.has(ssnString)) {
                        if (!has85Change) {
                            hasSecond85Change = true;
                            changedMembers.push(beforeChangesMemberArray);
                        }
                        memberArray[second85Index + 3] = "";
                    }
                    //has second 85 but not on old sheet so a new addition just gets cleared volumes
                    else if (second85Index >= 0){
                        memberArray[second85Index + 3] = "";
                    }
                    //was on old, had volume previously, but cleared it so they are added to changes if not already
                    else if (mapSecond85.has(ssnString) && mapSecond85.get(ssnString) !== 0 && !has85Change) {
                        hasSecond85Change = true;
                        changedMembers.push(beforeChangesMemberArray);
                    }

                    let index93: number = memberArray.indexOf(93);

                    //has 93, was on old sheet, and did not change so it just gets cleared
                    if (index93 >= 0 && map93.has(ssnString) && (map93.get(ssnString) === beforeChangesMemberArray[index93 + 3])) {
                        memberArray[index93 + 3] = "";
                    }
                    //has 93 and was on old so gets added to changes if not already and cleared
                    else if (index93 >= 0 && map93.has(ssnString)) {
                        if (!has85Change && !hasSecond85Change) {
                            changedMembers.push(beforeChangesMemberArray);
                        }
                        memberArray[index93 + 3] = "";
                    }
                    //has 93 but not on old sheet so a new addition just gets cleared volumes
                    else if (index93 >= 0){
                        memberArray[index93 + 3] = "";
                    }
                    //was on old, had volume previously, but cleared it so they are added to changes if not already
                    else if (map93.has(ssnString) && map93.get(ssnString) !== 0 && !has85Change  && !hasSecond85Change) {
                        changedMembers.push(beforeChangesMemberArray);
                    }
                }
                //add each member
                updatedNewArray.push(memberArray);
            }

            //new workbook 1
            const updatedNewWorkbook = utils.book_new();

            let ws1 = utils.aoa_to_sheet(updatedNewArray);

            //add it to the new workbook
            utils.book_append_sheet(updatedNewWorkbook, ws1, "UpdatedPropelusMed");

            //new workbook 2
            const changedMembersWorkbook = utils.book_new();

            let ws2 = utils.aoa_to_sheet(changedMembers);

            //add it to the workbook
            utils.book_append_sheet(changedMembersWorkbook, ws2, "PropelusMedChangedMembers");

            //it exists send it back to app for export
            if (changedMembersWorkbook && updatedNewWorkbook) {
                //giving the workbook props
                if(!updatedNewWorkbook.Props) updatedNewWorkbook.Props = {};

                //setting the workbook title through props
                updatedNewWorkbook.Props.Title = excelData.FileName + " Updated.csv";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(updatedNewWorkbook, excelData.FileName + " Updated.csv",{});

                if(!changedMembersWorkbook.Props) changedMembersWorkbook.Props = {};
                //setting the workbook title through props
                changedMembersWorkbook.Props.Title = excelData.FileName + " Changed Members.csv";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(changedMembersWorkbook, excelData.FileName + " Changed Members.csv",{});

                console.log("File Export Complete!");

                setSuccessAlert(true);
            }
            else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }
            //reset so old data doesnt download on rerender
            excelData.Sheets.NewSheet = undefined;
            excelData.Sheets.OldSheet = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);
        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.OldSheet = undefined;
        excelData.Sheets.NewSheet = undefined;
    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}

export default React.memo(FileComparer)

FileComparer.propTypes = {
    excelData: PropTypes.object.isRequired
};